module.exports = "../images/fishing-lure-2@2x.png?v=e9e23ba";